import * as moment from 'moment';
import * as XLSX from 'xlsx-js-style';
import html2pdf from 'html2pdf.js';
import { organisationSignal } from '../signal/organisationSignal';
import { dealerSignal } from '../signal/dealerSignal';
import { allUsersSignal } from '../signal/allUsersSignal';

export const expenseSheetGenerator = (data, periodicData) => {
    // initialize an empty worksheet
    let sheetData = [
        ['Title', 'Description', 'Amount', 'Date', 'Status', 'Reviewed By', 'Reason'],
    ];
    let totalExpense = 0;
    data.map((item) => {
        sheetData.push([
            item.title,
            item.description,
            `₹ ${parseFloat(item.amount).toFixed(2)}`,
            moment(item.createdAt).format('DD/MM/YYYY hh:mm A'),
            item.status,
            item.status === 'pending' ? '' : (item?.reviewedBy?.length ? item?.reviewedBy[0]?.name : ''),
            item.reason,
        ]);

        if (item.status !== 'rejected') {
            totalExpense += item.amount;
        }
    });

    // Add Periodic Expenses
    periodicData.map((item) => {
        sheetData.push([
            item.title,
            "Default Expense set by Admin",
            `₹ ${parseFloat(item.amount).toFixed(2)}`,
            moment(item.createdAt).format('DD/MM/YYYY hh:mm A'),
            item.status,
            "-",
            "-",
        ]);
        totalExpense += item.amount;
    });

    // Add Total Amount Row with all cells merged
    sheetData.push(['Total Amount: ₹' + parseFloat(totalExpense).toFixed(2), '', '', '', '', '']);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['A1'].s = { font: { bold: true, sz: 12 } };
    ws['B1'].s = { font: { bold: true, sz: 12 } };
    ws['C1'].s = { font: { bold: true, sz: 12 } };
    ws['D1'].s = { font: { bold: true, sz: 12 } };
    ws['E1'].s = { font: { bold: true, sz: 12 } };
    ws['F1'].s = { font: { bold: true, sz: 12 } };


    // Applying styles to each data row
    data.map((item, i) => {
        const rowIndex = i + 2;
        const statusCellStyle =
            item.status === 'pending'
                ? { font: { color: { rgb: 'f16a1b' } } }
                : item.status === 'approved'
                    ? { font: { color: { rgb: '00FF00' } } }
                    : item.status === 'rejected'
                        ? { font: { color: { rgb: 'FF0000' } } }
                        : {};

        ws[`E${rowIndex}`].s = statusCellStyle;
    });

    // Applying styles to the total amount row
    const totalAmountRow = sheetData?.length;
    ws['!merges'] = [{ s: { r: totalAmountRow - 1, c: 0 }, e: { r: totalAmountRow - 1, c: 6 } }];

    ws[`A${totalAmountRow}`].s = { font: { bold: true }, alignment: { horizontal: 'left', wrapText: true, vertical: 'center' } };

    ws['!rows'] = [
        { hpx: 20 },
    ];

    ws['!cols'] = [
        { width: 20 },
        { width: 50 },
        { width: 20 },
        { width: 30 },
        { width: 20 },
        { width: 20 },
        { width: 40 },
    ];
    return ws;
};

export const expenseSheetGeneratorV2 = (data, periodicData, fromDate, toDate) => {
    // same as first one, but dates will be horizontal
    let sheetData = [
        ['Title', 'Description']
    ]
    console.log(fromDate, toDate);
    let currentDate = moment(fromDate);
    while (currentDate <= moment(toDate)) {
        sheetData[0].push(moment(currentDate).format('DD/MM'));
        currentDate = moment(currentDate).add(1, 'days');
    }
    sheetData[0].push('Total Amount');
    let expenseType = {};
    let totalAmount = {};
    let dateTotal = {};

    data.map((item) => {
        if (item.status === 'rejected') {
            return;
        }
        if (!expenseType[item.title]) {
            expenseType[item.title] = {}
            totalAmount[item.title] = 0;
        }
        if (!expenseType[item.title][moment(item.createdAt).format('DD/MM')]) {
            expenseType[item.title][moment(item.createdAt).format('DD/MM')] = 0;
        }
        expenseType[item.title][moment(item.createdAt).format('DD/MM')] += item.amount;
        totalAmount[item.title] += item.amount;
        if (!dateTotal[moment(item.createdAt).format('DD/MM')]) {
            dateTotal[moment(item.createdAt).format('DD/MM')] = 0;
        }
        dateTotal[moment(item.createdAt).format('DD/MM')] += item.amount;
    })

    periodicData.map((item) => {
        if (!expenseType[item.title]) {
            expenseType[item.title] = {}
            totalAmount[item.title] = 0;
        }
        if (!expenseType[item.title][moment(item.createdAt).format('DD/MM')]) {
            expenseType[item.title][moment(item.createdAt).format('DD/MM')] = 0;
        }
        expenseType[item.title][moment(item.createdAt).format('DD/MM')] += item.amount;
        totalAmount[item.title] += item.amount;
        if (!dateTotal[moment(item.createdAt).format('DD/MM')]) {
            dateTotal[moment(item.createdAt).format('DD/MM')] = 0;
        }
        dateTotal[moment(item.createdAt).format('DD/MM')] += item.amount;
    })

    Object.keys(expenseType).map((key) => {
        let temp = [key, ''];
        currentDate = moment(fromDate);
        while (currentDate <= moment(toDate)) {
            if (expenseType[key][moment(currentDate).format('DD/MM')]) {
                temp.push(`${parseFloat(expenseType[key][moment(currentDate).format('DD/MM')]).toFixed(2)}`);
            } else {
                temp.push('-');
            }
            currentDate = moment(currentDate).add(1, 'days');
        }
        temp.push(`₹ ${parseFloat(totalAmount[key]).toFixed(2)}`);
        sheetData.push(temp);
    })

    let temp = ['Total', ''];
    let total = 0;
    currentDate = moment(fromDate);
    while (currentDate <= moment(toDate)) {
        if (dateTotal[moment(currentDate).format('DD/MM')]) {
            temp.push(`₹ ${parseFloat(dateTotal[moment(currentDate).format('DD/MM')]).toFixed(2)}`);
            total += dateTotal[moment(currentDate).format('DD/MM')];
        } else {
            temp.push(`₹ 0.00`);
        }
        currentDate = moment(currentDate).add(1, 'days');
    }
    temp.push(`₹ ${parseFloat(total).toFixed(2)}`);
    sheetData.push(temp);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // style the first row to be bold
    for (let row = 0; row < sheetData.length; row++) {
        for (let col = 0; col < sheetData[row].length; col++) {
            ws[XLSX.utils.encode_cell({ r: row, c: col })].s = { font: { sz: 8, bold: (row && row!==sheetData.length-1) ? false : true }, alignment: { wrapText: true, vertical: 'center', horizontal: col ? 'center' : 'left' }};
        }
    }

    // all cells to have width of 30px
    let tp = [];
    for(let i=0; i<sheetData.length; i++) {
        tp.push({ hpx: 20 });
    }
    ws['!rows'] = tp;

    return ws;

}

export const tripSheetGenerator = (data) => {

    let sheetData = [
        ['Date', 'Route', 'Status', 'Start Time', 'End Time', 'startKm', 'endKm', 'Manual Km', 'Auto km', 'Difference', 'Distance', 'DA', 'Expense', 'Tasks', 'Tasks Completed']
    ]

    let totalDistance = 0;
    let totalManualKm = 0;
    let totalAutoKm = 0;
    let totalDA = 0;
    let totalExpense = 0;

    let todayStartTimeinMilli = moment().startOf('day').valueOf();



    data.map((item) => {
        let tripStatus = ""
        if (!item?.isStarted) {
            if (item?.date < todayStartTimeinMilli) {
                tripStatus = "Not Started"
            } else {
                tripStatus = "Scheduled"
            }
        } else if (!item?.isCompleted) {
            if (item?.date !== todayStartTimeinMilli) {
                tripStatus = "Not Ended"
            } else {
                tripStatus = "On Going"
            }
        } else if (item?.isCompleted) {
            if (item?.isNotEnded) {
                tripStatus = "Not Ended"
            } else {
                tripStatus = "Completed"
            }
        }

        let str = "";
        if(item?.route && item?.route !== ""){
            str = item?.route
        }

        let tasks = item?.tasks || []
        for (let i = 0; i < tasks?.length; i++) {
            if (i === 0) {
                if (tasks[i]?.destinationArea) {
                    str += `${tasks[i]?.destinationArea}, `
                }
                if (tasks[i]?.destinationCity) {
                    str += `${tasks[i]?.destinationCity}, `
                }
                if (tasks[i]?.destinationState) {
                    str += `${tasks[i]?.destinationState}, `
                }
            } else {
                if (str !== "") {
                    str += " -> "
                }

                if (tasks[i]?.destinationArea && tasks[i]?.destinationArea !== item?.tasks[i - 1]?.destinationArea) {
                    str += `${tasks[i]?.destinationArea}, `
                }
                if (tasks[i]?.destinationCity && tasks[i]?.destinationCity !== item?.tasks[i - 1]?.destinationCity) {
                    str += `${tasks[i]?.destinationCity}, `
                }
                if (tasks[i]?.destinationState && tasks[i]?.destinationState !== item?.tasks[i - 1]?.destinationState) {
                    str += `${tasks[i]?.destinationState}, `
                }
            }

        }
        sheetData.push([
            moment(item.date).format('DD/MM/YYYY'),
            str,
            tripStatus,
            item.startTime ? moment(item.startTime).format('hh:mm A') : '',
            item.endTime ? moment(item.endTime).format('hh:mm A') : '',
            item?.startKM ? item.startKM : "-",
            item?.endKM ? item.endKM : "-",
            parseFloat(item.manualDistance / 1000).toFixed(2),
            parseFloat(item.autoCalculatedDistance / 1000).toFixed(2),
            Math.abs(parseFloat((item.manualDistance - item.autoCalculatedDistance) / 1000).toFixed(2)),
            parseFloat(item.totalDistance / 1000).toFixed(2),
            parseFloat(item?.dailyAllowanceExpense ? item?.dailyAllowanceExpense : 0).toFixed(2),
            parseFloat(item.totalExpense).toFixed(2),
            item?.tasks?.length,
            item.tasksCompleted,
        ])
        totalDistance += item.totalDistance;
        totalManualKm += item.manualDistance
        totalAutoKm += item.autoCalculatedDistance
        totalDA += item.dailyAllowanceExpense;
        totalExpense += item.totalExpense;
    })

    sheetData.push([
        'Total',
        '',
        '',
        '',
        '',
        '',
        '',
        parseFloat(totalManualKm / 1000).toFixed(2),
        parseFloat(totalAutoKm / 1000).toFixed(2),
        '',
        parseFloat(totalDistance / 1000).toFixed(2),
        "₹ " + parseFloat(totalDA).toFixed(2),
        "₹ " + parseFloat(totalExpense).toFixed(2),
        '',
        '',
        
    ])

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['A1'].s = { font: { bold: true, sz: 12 } };
    ws['B1'].s = { font: { bold: true, sz: 12 } };
    ws['C1'].s = { font: { bold: true, sz: 12 } };
    ws['D1'].s = { font: { bold: true, sz: 12 } };
    ws['E1'].s = { font: { bold: true, sz: 12 } };
    ws['F1'].s = { font: { bold: true, sz: 12 } };
    ws['G1'].s = { font: { bold: true, sz: 12 } };
    ws['H1'].s = { font: { bold: true, sz: 12 } };
    ws['I1'].s = { font: { bold: true, sz: 12 } };
    ws['J1'].s = { font: { bold: true, sz: 12 } };
    ws['K1'].s = { font: { bold: true, sz: 12 } };
    ws['L1'].s = { font: { bold: true, sz: 12 } };

    for (let i = 1; i < sheetData?.length - 1; i++) {
        const rowIndex = i + 1;
        let statusCellStyleColor = ""
        if (sheetData[i][2] === "Not Started") {
            statusCellStyleColor = "001F4D"
        } else if (sheetData[i][2] === 'Scheduled') {
            statusCellStyleColor = "6410F1"
        } else if (sheetData[i][2] === 'Not Ended') {
            statusCellStyleColor = "FF0000"
        } else if (sheetData[i][2] === 'On Going') {
            statusCellStyleColor = "f16a1b"
        } else {
            statusCellStyleColor = "00FF00"
        }
        ws[`C${rowIndex}`].s = { font: { color: { rgb: statusCellStyleColor } } }
    }

    const totalAmountRow = sheetData?.length;

    ws[`A${totalAmountRow}`].s = { font: { bold: true }, alignment: { horizontal: 'left', wrapText: true, vertical: 'center' } };

    ws['!rows'] = [
        { hpx: 20 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
    ];

    ws['!cols'] = [
        { width: 20 },
        { width: 40 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 30 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
    ];

    return ws;
}

export const attendenceSheetGenerator = (leaves, attendences, fromDate, toDate) => {
    let sheetData = [
        ['Date', 'Status', 'Start Time', 'End Time', 'Reason']
    ]

    let leaveDetails = {}
    leaves.map((item) => {
        leaveDetails[item.id] = item;
    })

    let totalLeaves = 0;

    let dateMap = {};



    attendences.map((item) => {
        if (dateMap[moment(item?.startTime).format('DD/MM/YYYY')]) {
        } else {
            if (item.isPresent || item.leaveId !== "000000000000000000000000") {
                dateMap[moment(item?.startTime).format('DD/MM/YYYY')] = item;
            }
        }
    })

    let start = moment(fromDate);
    let end = moment(toDate);

    let totalAbsent = 0;

    while (start <= end) {

        let selectedDate = moment(new Date(start).getTime()).format("DD/MM/YYYY");

        if (!dateMap[selectedDate]) {


            let isThisSaturday = moment(start).day() === 6;
            let isThisSunday = moment(start).day() === 0;
            let thisDate = moment(start).format('DD/MM');
            let isHoliday = false;

            if (isThisSaturday && !organisationSignal?.value?.isSaturdayWorking) {
                isHoliday = true;
            }
            else if (isThisSunday && !organisationSignal?.value?.isSundayWorking) {
                isHoliday = true;
            }
            else if (organisationSignal?.value?.holidays !== undefined) {
                if (organisationSignal?.value?.holidays[thisDate]) {
                    isHoliday = true;
                }
            }


            if (!isHoliday) {
                dateMap[selectedDate] = {
                    isPresent: false,
                    startTime: selectedDate,
                    leaveId: "000000000000000000000000"
                }
            } else {
                dateMap[selectedDate] = {
                    isPresent: false,
                    isHoliday: true,
                    startTime: selectedDate,
                    leaveId: "000000000000000000000000"
                }
            }
        }

        let temp = dateMap[selectedDate];

        let sts = temp?.isPresent ? 'Present' : (temp?.leaveId !== "000000000000000000000000" ? 'Leave' : (temp?.isHoliday ? "Holiday" : "Absent"))

        sheetData.push([
            selectedDate,
            sts,
            !temp.isPresent && temp?.leaveId === "000000000000000000000000" ? '' : (temp?.startTime ? moment(temp?.startTime).format('hh:mm A') : ''),
            !temp.isPresent && temp?.leaveId === "000000000000000000000000" ? '' : (temp?.endTime ? moment(temp?.endTime).format('hh:mm A') : ''),
            leaveDetails[temp?.id] ? leaveDetails[temp?.id].reason : ''
        ])
        if (!temp.isPresent) {

            if (sts === "Absent") {
                totalAbsent += 1;
            } else {

                if (sts === "Leave") {
                    let days = temp.endTime ? moment(temp.endTime).diff(moment(temp.startTime), 'days') : 1;
                    if (days === 0 && temp.endTime) {
                        days = 1;
                    }
                    totalLeaves += days;
                }
            }
        }

        start = moment(start).add(1, 'days');
    }



    sheetData.push([
        'Total ' + totalLeaves + " leaves"
    ])

    sheetData.push([
        'Total ' + totalAbsent + " absent"
    ])

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['A1'].s = { font: { bold: true, sz: 12 } };
    ws['B1'].s = { font: { bold: true, sz: 12 } };
    ws['C1'].s = { font: { bold: true, sz: 12 } };
    ws['D1'].s = { font: { bold: true, sz: 12 } };
    ws['E1'].s = { font: { bold: true, sz: 12 } };

    for (let i = 1; i < sheetData?.length - 2; i++) {
        const rowIndex = i + 1;
        const statusCellStyle = sheetData[i][1] === 'Present' ? { font: { color: { rgb: '00FF00' } } } : { font: { color: { rgb: 'FF0000' } } };

        ws[`B${rowIndex}`].s = statusCellStyle;
    }

    const totalAmountRow = sheetData?.length;

    ws["!merges"] = [{ s: { r: totalAmountRow - 1, c: 0 }, e: { r: totalAmountRow - 1, c: 4 } }]

    ws[`A${totalAmountRow}`].s = { font: { bold: true }, alignment: { horizontal: 'left', wrapText: true, vertical: 'center' } };

    ws['!rows'] = [
        { hpx: 20 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
        { hpx: 15 },
    ];

    ws['!cols'] = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 30 },
    ];
    return ws;
}

const TripSummarySheetGenerator = async (data, userData) => {
    let sheetData = []

    let totalAbsentEmployees = 0;
    let totalPresentEmployees = 0;
    let todayStartTimeinMilli = moment().startOf('day').valueOf();

    data.map((item) => {

        let route = "";
        if (item?.trip === false) {
            route = "-"
        }
        let tasks = item?.tasks || [];
        for (let i = 0; i < tasks?.length; i++) {
            if (i === 0) {
                if (tasks[i]?.destinationArea) {
                    route += `${tasks[i]?.destinationArea}, `
                }
                if (tasks[i]?.destinationCity) {
                    route += `${tasks[i]?.destinationCity}, `
                }
                if (tasks[i]?.destinationState) {
                    route += `${tasks[i]?.destinationState}, `
                }
            } else {
                if (route !== "") {
                    route += " -> "
                }

                if (tasks[i]?.destinationArea && tasks[i]?.destinationArea !== item?.tasks[i - 1]?.destinationArea) {
                    route += `${tasks[i]?.destinationArea}, `
                }
                if (tasks[i]?.destinationCity && tasks[i]?.destinationCity !== item?.tasks[i - 1]?.destinationCity) {
                    route += `${tasks[i]?.destinationCity}, `
                }
                if (tasks[i]?.destinationState && tasks[i]?.destinationState !== item?.tasks[i - 1]?.destinationState) {
                    route += `${tasks[i]?.destinationState}, `
                }
            }

        }

        let tripStatus = ""
        let isPresent = false;
        if (item?.trip === false) {
            tripStatus = "Not Started"
        } else if (!item?.isStarted) {
            if (item?.date < todayStartTimeinMilli) {
                tripStatus = "Not Started"
            } else {
                tripStatus = "Scheduled"
            }
        } else if (!item?.isCompleted) {
            if (item?.date !== todayStartTimeinMilli) {
                tripStatus = "Not Ended"
            } else {
                tripStatus = "On Going"
            }
        } else if (item?.isCompleted) {
            if (item?.isNotEnded) {
                tripStatus = "Not Ended"
            } else {
                tripStatus = "Completed"
                isPresent = true;
            }
        }

        sheetData.push([
            userData[item.userId].name,
            isPresent ? "Present" : "Absent",
            tripStatus,
            item?.trip === false ? "-" : (item.startTime ? moment(item.startTime).format('hh:mm A') : ''),
            item?.trip === false ? "-" : (item.endTime ? moment(item.endTime).format('hh:mm A') : ''),
            item?.trip === false ? "-" : (item?.startKM ? item.startKM : "-"),
            item?.trip === false ? "-" : (item?.endKM ? item.endKM : "-"),
            item?.trip === false ? "-" : (parseFloat(item.manualDistance / 1000).toFixed(2) + " km"),
            item?.trip === false ? "-" : (parseFloat(item.autoCalculatedDistance / 1000).toFixed(2) + " km"),
            item?.trip === false ? "-" : (parseFloat(item.totalDistance / 1000).toFixed(2) + " km"),
            item?.trip === false ? "-" : (parseFloat(item.dailyAllowanceExpense ? item.dailyAllowanceExpense : 0).toFixed(2)),
            item?.trip === false ? "-" : (parseFloat(item.totalExpense).toFixed(2)),
            route
        ])

        if (item?.trip === false) {
            totalAbsentEmployees += 1;
        } else {
            if (!item?.isStarted) {
                totalAbsentEmployees += 1;
            } else {
                totalPresentEmployees += 1;
            }

        }
    })

    let html = `
    <html>
    <head>
    </head>
    <body style="width: 98%;">
    <h2>Trip Summary</h2>
    <table style="width:100%; border-collapse: collapse; border: 1px solid black;">
    <tr>
        <th style="border: 1px solid black;">User</th>
        <th style="border: 1px solid black;">Attendence</th>
        <th style="border: 1px solid black;">Status</th>
        <th style="border: 1px solid black;">Start Time</th>
        <th style="border: 1px solid black;">End Time</th>
        <th style="border: 1px solid black;">Start KM</th>
        <th style="border: 1px solid black;">End KM</th>
        <th style="border: 1px solid black;">Manual KM</th>
        <th style="border: 1px solid black;">Auto KM</th>
        <th style="border: 1px solid black;">Distance</th>
        <th style="border: 1px solid black;">DA</th>
        <th style="border: 1px solid black;">Expense</th>
        <th style="border: 1px solid black;">Route</th>
    </tr>

    ${sheetData.map((item) => {

        let statusCellStyleColor = ""
        if (item[2] === "Not Started") {
            statusCellStyleColor = "001F4D"
        } else if (item[2] === 'Scheduled') {
            statusCellStyleColor = "6410F1"
        } else if (item[2] === 'Not Ended') {
            statusCellStyleColor = "FF0000"
        } else if (item[2] === 'On Going') {
            statusCellStyleColor = "f16a1b"
        } else {
            statusCellStyleColor = "00FF00"
        }

        return `<tr>
        <td style="border: 1px solid black; width: 20%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[0]}</td>
        <td style="border: 1px solid black; width: 7%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[1]}</td>
        <td style="color: ${statusCellStyleColor}; border: 1px solid black; width: 7%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[2]}</td>
        <td style="border: 1px solid black; width: 3%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[3]}</td>
        <td style="border: 1px solid black; width: 3%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[4]}</td>
        <td style="border: 1px solid black; width: 4%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[5]}</td>
        <td style="border: 1px solid black; width: 4%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[6]}</td>
        <td style="border: 1px solid black; width: 4%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[7]}</td>
        <td style="border: 1px solid black; width: 4%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[8]}</td>
        <td style="border: 1px solid black; width: 8%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[9]}</td>
        <td style="border: 1px solid black; width: 8%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[10]}</td>
        <td style="border: 1px solid black; width: 8%; white-space: normal; word-wrap: break-word; text-overflow: wrap;">${item[11]}</td>
        <td style="border: 1px solid black; width: 20%; white-space: normal; word-wrap: break-word; text-overflow: wrap;"><p style="">${item[12]}</p></td>
        </tr>`
    })}

    </table>
    <h3>Total Absent Employees: ${totalAbsentEmployees}</h3>
    <h3>Total Present Employees: ${totalPresentEmployees}</h3>

    </body>
    </html>
    
    `

    // open new tab
    const newWindow = window.open('Trip-summary', '_blank');
    newWindow.document.open();
    newWindow.document.write(html);
    newWindow.print();

    return html;

}

const attendenceDataSheetGenerator = (data, columns, userData) => {
    let sheetData = []
    let temp = []

    columns.map((column) => {
        temp.push(column?.name)
    })

    sheetData.push(temp)

    Object.values(data).map((item) => {
        let temp = []
        columns.map((column) => {
            if (column.name === "User") {
                temp.push(userData[item.userId]?.name || "")
            } else if (column.name === "P") {
                temp.push(item["fullDay"] || 0)
            } else if (column.name === "P/2") {
                temp.push(item["halfDay"] || 0)
            } else if (column.name === "P/4") {
                temp.push(item["quarterDay"] || 0)
            } else if (column.name === "Expense") {
                temp.push(parseFloat(item["expense"] || 0).toFixed(2))
            } else if (column.name === "A") {
                temp.push(item["absents"] || 0)
            } else if (column.name === "WO") {
                temp.push(item["weekOffs"] || 0)
            } else if (column.name === "L") {
                temp.push(item["leaves"] || 0)
            } else if (column.name === "H") {
                temp.push(item["holidays"] || 0)
            } else if (column.name === "Department") {
                temp.push((userData[item.userId]?.state || "").toUpperCase())
            } else if (column.name === "Designation") {
                temp.push(userData[item.userId]?.designation || "")
            }
            else {
                if (item[column.name]) {
                    temp.push(item[column.name])
                } else {
                    temp.push("-")
                }
            }
        })
        sheetData.push(temp)
    })

    // all cells to have width of 30px



    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // ws['!rows'] = sheetData.map(() => ({ hpx: 20, s: { font: { sz: 8 } } }));


    for (let row = 0; row < sheetData.length; row++) {
        for (let col = 0; col < sheetData[row].length; col++) {
            ws[XLSX.utils.encode_cell({ r: row, c: col })].s = { font: { sz: 8, bold: row ? false : true }, alignment: { wrapText: true, vertical: 'center', horizontal: col ? 'center' : 'left' }};
        }
    }
    

    let tempColWidth = sheetData[0].map(() => ({ width: 4}));
    tempColWidth[0] = { width: 20 };
    tempColWidth[tempColWidth.length - 3] = { width: 10 };
    tempColWidth[tempColWidth.length - 2] = { width: 12 };
    tempColWidth[tempColWidth.length - 1] = { width: 15 };
    ws['!cols'] = tempColWidth;

    ws['!rows'] = sheetData.map(() => ({ hpx: 20}));


    return ws;
}

export const paymentsSheetGenerator = (data) => {
    let sheetData = [
        ['Date', 'Dealer', 'Amount', 'Payment Mode', 'Payment Status', 'Payment Remarks', 'Received By']
    ]

    data.map((row) => {
        sheetData.push([
            moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
            row?.dealerId?.length>0 ? row?.dealerId[0]?.name : '',
            `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            row?.paymentType,
            row?.status,
            row?.remark,
            row?.userId?.length>0 ? row?.userId[0]?.name : ''
        ])
    })

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['A1'].s = { font: { bold: true, sz: 12 } };
    ws['B1'].s = { font: { bold: true, sz: 12 } };
    ws['C1'].s = { font: { bold: true, sz: 12 } };
    ws['D1'].s = { font: { bold: true, sz: 12 } };
    ws['E1'].s = { font: { bold: true, sz: 12 } };
    ws['F1'].s = { font: { bold: true, sz: 12 } };
    ws['G1'].s = { font: { bold: true, sz: 12 } };

    for (let i = 1; i < sheetData?.length; i++) {
        const rowIndex = i + 1;
        const statusCellStyle = sheetData[i][4] === 'pending' ? { font: { color: { rgb: 'f16a1b' } } } : sheetData[i][4] === 'cleared' ? { font: { color: { rgb: '00FF00' } } } : { font: { color: { rgb: 'FF0000' } } };

        ws[`E${rowIndex}`].s = statusCellStyle;
    }

    ws['!rows'] = [
        { hpx: 20 },
    ];

    ws['!cols'] = [
        { width: 20 },
        { width: 50 },
        { width: 20 },
        { width: 30 },
        { width: 20 },
        { width: 20 },
        { width: 40 },
    ];

    return ws;

}

export const dealerVisitsSheetGenerator = (data) => {
    let sheetData = [
        ['Title', 'Description', 'Dealer', 'Remarks', 'Address', 'Completed At', 'User'],
    ]

    data.map((row) => {
        sheetData.push([
            row?.title,
            row?.description,
            dealerSignal?.value[row?.dealerId]?.name,
            row?.remarks,
            `${row?.destinationArea !== "" ? row?.destinationArea + ", " : ""}${row?.destinationCity !== "" ? row?.destinationCity + ", " : ""}${row?.destinationState !== "" ? row?.destinationState + ", " : ""}`,
            moment(row?.completedAt).format("DD/MM/YY hh:mm A"),
            allUsersSignal.value[row?.userId]?.name
        ])
    })

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['A1'].s = { font: { bold: true, sz: 12 } };
    ws['B1'].s = { font: { bold: true, sz: 12 } };
    ws['C1'].s = { font: { bold: true, sz: 12 } };
    ws['D1'].s = { font: { bold: true, sz: 12 } };
    ws['E1'].s = { font: { bold: true, sz: 12 } };
    ws['F1'].s = { font: { bold: true, sz: 12 } };
    ws['G1'].s = { font: { bold: true, sz: 12 } };

    ws['!rows'] = [
        { hpx: 20 },
    ];

    ws['!cols'] = [
        { width: 20 },
        { width: 50 },
        { width: 20 },
        { width: 30 },
        { width: 20 },
        { width: 20 },
        { width: 40 },
    ];

    return ws;
}

export const attendenceExcelGenerator = (attendencesData, columns, userData, fileName) => {
    const wb = XLSX.utils.book_new();
    const attendenceSheet = attendenceDataSheetGenerator(attendencesData, columns, userData);
    XLSX.utils.book_append_sheet(wb, attendenceSheet, 'Attendence Sheet');
    XLSX.writeFile(wb, fileName + '.xlsx');
}

export const userExcelGenerator = (expenses, leaves, trips, attendences, periodicExpenses, fileName, fromDate, toDate) => {
    const wb = XLSX.utils.book_new();
    // const expenseSheet = expenseSheetGenerator(expenses, periodicExpenses);
    const expenseSheetV2 = expenseSheetGeneratorV2(expenses, periodicExpenses, fromDate, toDate);
    const tripSheet = tripSheetGenerator(trips);
    const attendenceSheet = attendenceSheetGenerator(leaves, attendences, fromDate, toDate);
    XLSX.utils.book_append_sheet(wb, tripSheet, 'Trips');
    XLSX.utils.book_append_sheet(wb, expenseSheetV2, 'Expenses');
    XLSX.utils.book_append_sheet(wb, attendenceSheet, 'Attendence');
    XLSX.writeFile(wb, fileName + '.xlsx');
};

export const paymentsExcelGenerator = (payments, fileName) => {
    const wb = XLSX.utils.book_new();
    const paymentsSheet = paymentsSheetGenerator(payments);
    XLSX.utils.book_append_sheet(wb, paymentsSheet, 'Payments');
    XLSX.writeFile(wb, fileName + '.xlsx');

}

export const dealerVisitsExcelGenerator = (dealerVisits, fileName) => {
    const wb = XLSX.utils.book_new();
    const dealerVisitsSheet = dealerVisitsSheetGenerator(dealerVisits);
    XLSX.utils.book_append_sheet(wb, dealerVisitsSheet, 'Dealer Visits');
    XLSX.writeFile(wb, fileName + '.xlsx');
}

export const tripSummmaryPDFGenerator = async (userTrips, userData, fileName) => {
    const TripSummarySheet = TripSummarySheetGenerator(userTrips, userData);

    let opt = {
        margin: 0.1,
        filename: fileName,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' }
    }

    // await html2pdf().from(TripSummarySheet).set(opt).save(fileName);
    // html2pdf(htmlContent)
    //   .then((pdfData) => {
    //     const fileName = 'Trip_Summary.pdf'; // Adjust filename as needed
    //     const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
    //     // Use the Blob to trigger a download or save it to the server
    //   })
    //   .catch((error) => {
    //     console.error('Error converting to PDF:', error);
    //   });

    // XLSX.writeFile(wb, fileName + '.xlsx');
}